/* Modal açıkken arkadaki sayfa kaydırılmasın. İki modal host'u (route modalı ve
   ModalHost) aynı anda açık olabildiği için kilit sayaçlıdır: ilki kapanınca
   kilit düşmez, sonuncusu kapanınca düşer. */

let lockCount = 0;

export function lockBodyScroll() {
    lockCount += 1;
    document.body.classList.add("est-modal-open");
}

export function unlockBodyScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
        document.body.classList.remove("est-modal-open");
    }
}
